export default __webpack_public_path__ + "static/media/reino-unido-flag.4969a86e.svg";